(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("haphazard", [], factory);
	else if(typeof exports === 'object')
		exports["haphazard"] = factory();
	else
		root["haphazard"] = factory();
})(global, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./lib/haphazard.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./lib/haphazard.js":
/*!**************************!*\
  !*** ./lib/haphazard.js ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// short period, not very useful; the longer the seed the longer the period it seems

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MiddleSquare = exports.MiddleSquare = function () {
    function MiddleSquare(seed) {
        _classCallCheck(this, MiddleSquare);

        this.string_size = (seed + "").length;
        this.zero_string = Array.from(Array(this.string_size), function () {
            return 0;
        }).join("");

        if (seed != parseInt(seed)) {
            throw new Error("seed is not an integer");
        }

        if (seed + "" === this.zero_string) {
            throw "0* is not a valid seed";
        }

        this.initial = seed;
        this.seed = seed;
    }

    _createClass(MiddleSquare, [{
        key: "next",
        value: function next() {
            var as_string = (this.seed * this.seed + "").padStart(this.string_size * 2, "0");

            this.seed = as_string.substring(this.string_size / 2, this.string_size + this.string_size / 2);

            // start again if "0*" generated
            if (this.seed + "" === this.zero_string) {
                this.seed = this.initial;
            }

            return this.seed;
        }
    }, {
        key: "next_float",
        value: function next_float() {
            var rand_integer = this.next();
            var rand_string = "0." + rand_integer.toString();
            var rand_float = Number(parseFloat(rand_string));
            if (isNaN(rand_float)) {
                throw new Error("could not convert " + rand_string + " to float");
            }
            return rand_float;
        }
    }]);

    return MiddleSquare;
}();

// primes from here https://www2.cs.arizona.edu/icon/oddsends/primes.htm


var BBS = exports.BBS = function () {
    function BBS(seed) {
        var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 23773;
        var q = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 19069;

        _classCallCheck(this, BBS);

        if (seed !== parseInt(seed)) {
            throw new Error("seed " + seed + " is not an integer");
        }

        this.p = p;
        this.q = q;
        this.M = this.p * this.q;
        this.seed = seed;
    }

    _createClass(BBS, [{
        key: "next",
        value: function next() {
            var next = this.seed * this.seed % this.M;
            this.seed = next;
            return next;
        }
    }, {
        key: "next_float",
        value: function next_float() {
            var rand_integer = this.next();
            var rand_string = "0." + rand_integer.toString();
            var rand_float = Number(parseFloat(rand_string));
            if (isNaN(rand_float)) {
                throw new Error("could not convert " + rand_string + " to float");
            }
            return rand_float;
        }
    }]);

    return BBS;
}();

/***/ })

/******/ });
});
//# sourceMappingURL=haphazard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/haphazard/dist/haphazard.js
// module id = 23
// module chunks = 0